// extracted by mini-css-extract-plugin
module.exports = {"DimensionsFeature":"wk_a bhs_b bhs_ux"};